import React from 'react';

import * as helpers from './helpers';

const RingHeightIcon = ({
  color,
  width = 42,
  height = 66,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg {...helpers.getSvgDimensionsProps({ width, height })} {...props}>
    <path
      d="M41.3028 38.9055C41.3028 55.2184 32.2787 65.2838 22.9075 65.2838C21.6091 65.2838 18.2854 65.2838 17.0071 65.2838C6.08082 65.2838 25.6843 58.3421 25.6842 38.9055C25.6842 20.5101 6.96338 12.527 17.0071 12.5272C17.7012 12.5272 22.2041 12.5272 22.9075 12.5272C33.8337 12.5272 41.3028 22.5926 41.3028 38.9055Z"
      fill="#DBDBDB"
    />
    <path
      d="M6.24755 19.1218H20.4779C20.4779 19.1218 13.5363 24.6751 13.5363 38.5584C13.5363 52.4417 20.4779 58.6892 20.4779 58.6892H6.94171L5.2063 38.5584L6.24755 19.1218Z"
      fill="#C4C4C4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6897 54.0211C22.7793 50.4919 24.2958 45.1639 24.2958 38.9055C24.2958 32.6472 22.7793 27.3191 20.6897 23.79C18.5096 20.108 16.4897 19.4689 15.6187 19.4689C14.7478 19.4689 12.7279 20.108 10.5477 23.79C8.45813 27.3191 6.94165 32.6472 6.94165 38.9055C6.94165 45.1639 8.45813 50.4919 10.5477 54.0211C12.7279 57.703 14.7478 58.3421 15.6187 58.3421C16.4897 58.3421 18.5096 57.703 20.6897 54.0211ZM15.6187 65.2838C24.2447 65.2838 31.2374 53.4738 31.2374 38.9055C31.2374 24.3372 24.2447 12.5272 15.6187 12.5272C6.99274 12.5272 0 24.3372 0 38.9055C0 53.4738 6.99274 65.2838 15.6187 65.2838Z"
      fill="#C3A573"
    />
    <path
      d="M16.75 1C16.75 0.585787 16.4142 0.25 16 0.25C15.5858 0.25 15.25 0.585786 15.25 1L16.75 1ZM15.4697 12.5303C15.7626 12.8232 16.2374 12.8232 16.5303 12.5303L21.3033 7.75736C21.5962 7.46447 21.5962 6.98959 21.3033 6.6967C21.0104 6.40381 20.5355 6.40381 20.2426 6.6967L16 10.9393L11.7574 6.6967C11.4645 6.40381 10.9896 6.40381 10.6967 6.6967C10.4038 6.98959 10.4038 7.46447 10.6967 7.75736L15.4697 12.5303ZM15.25 1L15.25 12L16.75 12L16.75 1L15.25 1Z"
      fill="#444449"
    />
    <path
      d="M16.75 31C16.75 31.4142 16.4142 31.75 16 31.75C15.5858 31.75 15.25 31.4142 15.25 31L16.75 31ZM15.4697 19.4697C15.7626 19.1768 16.2374 19.1768 16.5303 19.4697L21.3033 24.2426C21.5962 24.5355 21.5962 25.0104 21.3033 25.3033C21.0104 25.5962 20.5355 25.5962 20.2426 25.3033L16 21.0607L11.7574 25.3033C11.4645 25.5962 10.9896 25.5962 10.6967 25.3033C10.4038 25.0104 10.4038 24.5355 10.6967 24.2426L15.4697 19.4697ZM15.25 31L15.25 20L16.75 20L16.75 31L15.25 31Z"
      fill="#444449"
    />
  </svg>
);

export default RingHeightIcon;
